import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {IMeta, MetaService} from "@shared/services/web/meta.service";
import {BreadcrumbsService} from "@shared/services/web/breadcrumbs.service";

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
})
export class CookiesPolicyComponent implements OnInit {
  constructor(
    private translateService: TranslateService,
    private metaService: MetaService,
    private breadcrumbsService: BreadcrumbsService
  ) {
    this.changeMeta();
    this.setBreadcrumb();
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'cookies',
      description: 'cookies_desc',
    };
    this.metaService.changeMeta(meta);
  }

  ngOnInit() {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeMeta();
    });
  }

  setBreadcrumb() {
    this.breadcrumbsService.setBreadcrumb([
      { label: 'Inicio', label_en: 'Home', path: '/' },
      { label: 'Política de cookies', label_en: 'Cookies policy', path: null },
    ]);
  }
}
